import icon from '@material-ui/icons/Person'

const domains = { icon, options: { label: 'domains' } }

export default domains
